import { z } from 'zod';
import type { AdPlatform } from '@/shared/types/enums';
import { PLATFORM_CREATIVE_CONSTRAINTS } from '../../logic/platform-constraints';

/**
 * Field limits follow the campaign's platform, so an edit can't save copy the ad
 * platform would later reject.
 */
export function createCreativeEditSchema(platform: AdPlatform) {
  const constraints = PLATFORM_CREATIVE_CONSTRAINTS[platform];
  const headlineMax = constraints.headlines.maxLength;
  const descriptionMax = constraints.descriptions.maxLength;

  return z.object({
    headline: z
      .string()
      .trim()
      .min(1, 'Headline is required')
      .max(headlineMax, `Headline must be ${headlineMax} characters or less`),
    description: z
      .string()
      .trim()
      .max(descriptionMax, `Description must be ${descriptionMax} characters or less`),
    callToAction: z.string().min(1, 'Please select a call to action'),
    destinationUrl: z.union([z.literal(''), z.string().trim().url('Please enter a valid URL')]),
  });
}

export type CreativeEditFormValues = z.infer<ReturnType<typeof createCreativeEditSchema>>;
